import styled from "styled-components";

export const Box = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }

  :root {
    --color-primary: #2563eb;
    --color-primary-hover: #1d4ed8;
    --color-gray-50: #f9fafb;
    --color-gray-100: #f3f4f6;
    --color-gray-200: #e5e7eb;
    --color-gray-300: #d1d5db;
    --color-gray-400: #9ca3af;
    --color-gray-500: #6b7280;
    --color-gray-600: #4b5563;
    --color-gray-700: #374151;
    --color-gray-800: #1f2937;
    --color-gray-900: #111827;
    --color-red-50: #fef2f2;
    --color-red-600: #dc2626;
    --color-yellow-50: #fefce8;
    --color-yellow-600: #ca8a04;
    --color-green-50: #f0fdf4;
    --color-green-600: #16a34a;
    --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1),
      0 4px 6px -4px rgb(0 0 0 / 0.1);
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, sans-serif;
    line-height: 1.5;
    color: #111827;
  }

  .container_roas {
    max-width: 64rem;
    margin: 0 auto;
  }

  .container_roas .header {
    text-align: center;
    margin-bottom: 2rem;
  }

  .container_roas .header h1 {
    font-size: 2.25rem;
    font-weight: 700;
    color: #111827;
  }

  .container_roas .header p {
    margin-top: 0.5rem;
    color: #4b5563;
  }

  .container_roas .calculator-form {
    margin-bottom: 2rem;
  }

  .container_roas .form-section {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .container_roas .form-grid {
    display: grid;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
    background-color: white;
    padding: 2rem;
    border-radius: 0.75rem;
    box-shadow: var(--shadow);
  }

  .container_roas .form-group-roas {
    margin-bottom: 1.5rem;
    width: 50%;
    padding: 10px !important;
  }

  .container_roas .form-group-full {
    margin-bottom: 0;
    width: 100%;
  }

  .container_roas .form-group-roas label {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    margin-bottom: 0.25rem;
  }

  .container_roas .form-group-roas input,
  .container_roas .form-group-roas select {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 0.5rem;
    background-color: white;
    color: #111827;
    transition: all 0.15s ease-in-out;
    font-size: 1rem;
  }

  .container_roas .form-group-roas input:focus,
  .container_roas .form-group-roas select:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }

  .container_roas .submit-button {
    width: 100%;
    padding: 0.875rem 1.5rem;
    background-color: #8CC540;
    color: white;
    border: none;
    border-radius: 0.5rem;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    justify-content: center;
  }

  .container_roas .submit-button:hover {
    background-color: #8CC540;
    transform: translateY(-1px);
  }

  .container_roas .submit-button:active {
    transform: translateY(0);
  }

  .container_roas .error-message {
    display: flex;
    align-items: center;
    padding: 1rem;
    margin-bottom: 1rem;
    background-color: #fef2f2;
    border-left: 4px solid #dc2626;
    border-radius: 0.375rem;
    color: red;
  }

  .container_roas .error-icon {
    width: 1.25rem;
    height: 1.25rem;
    stroke: #dc2626;
    margin-right: 0.75rem;
  }

  .container_roas .hidden {
    display: none;
  }

  .container_roas .results {
    margin-top: 2rem;
  }

  .container_roas .results-grid {
    border-radius: 0.75rem;
    box-shadow: var(--shadow-lg);
    overflow: hidden;
    margin-bottom: 1.5rem;
  }

  .container_roas .results-grid-excellent {
    background-color: #f0fdf4;
  }

  .container_roas .results-grid-low {
    background-color: #fef2f2;
  }

  .container_roas .results-grid-average {
    background-color: #efeac3;
  }

  .container_roas .results-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-bottom: 1px solid #e5e7eb;
  }

  .container_roas .results-header h2 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #111827;
  }

  .container_roas .trend-icon,
  .container_roas .target-icon,
  .container_roas .chart-icon {
    width: 1.5rem;
    height: 1.5rem;
    stroke: #2563eb;
  }

  .container_roas .metrics-grid {
    display: grid;
    gap: 1.5rem;
    padding: 1.5rem;
  }

  .container_roas .metric-card {
    background-color: white;
    padding: 1.5rem;
    border-radius: 0.5rem;
    box-shadow: var(--shadow-sm);
  }

  .container_roas .metric-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  .container_roas .metric-header h3 {
    font-size: 1.125rem;
    font-weight: 500;
    margin: 0;
    color: #374151;
  }

  .container_roas .metric-value {
    font-size: 2rem;
    font-weight: 700;
    margin: 0.5rem 0;
  }

  .container_roas .metric-value-green {
    color: #16a34a;
  }

  .container_roas .metric-value-yellow {
    color: #ebda47;
  }

  .container_roas .metric-value-red {
    color: #d11c1c;
  }

  .container_roas .metric-status {
    font-size: 0.875rem;
    color: #6b7280;
  }

  .container_roas .key-metrics p {
    font-size: 0.875rem;
    color: #4b5563;
    margin-bottom: 0.25rem;
  }

  .container_roas .key-metrics span {
    font-weight: 500;
  }

  .container_roas .recommendations {
    background-color: white;
    border-radius: 0.75rem;
    box-shadow: var(--shadow-lg);
    padding: 1.5rem;
  }

  .container_roas .recommendations-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }

  .container_roas .recommendations-header h2 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #111827;
  }

  .container_roas .recommendations-header span {
    font-size: 0.875rem;
    color: #6b7280;
  }

  .container_roas .recommendations-grid {
    display: grid;
    gap: 1.5rem;
  }

  .container_roas .recommendation-item {
    display: flex;
    align-items: flex-start;
    padding: 1rem;
    background-color: #f9fafb;
    border-radius: 0.5rem;
    transition: all 0.2s ease-in-out;
  }

  .container_roas .recommendation-item:hover {
    background-color: #f3f4f6;
    transform: translateY(-2px);
  }

  .container_roas .recommendation-number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    background-color: #2563eb;
    color: white;
    border-radius: 9999px;
    font-size: 0.875rem;
    font-weight: 500;
    margin-right: 0.75rem;
    flex-shrink: 0;
  }

  .container_roas .recommendation-text {
    color: #374151;
  }

  /* Mobile-specific styles */
  @media (max-width: 767px) {
    .container_roas {
      padding: 0 1rem;
    }

    .container_roas .form-grid {
      padding: 1rem;
      gap: 1rem;
    }

    .container_roas .form-group-roas {
      width: 100%;
      padding: 0 !important;
      margin-bottom: 1rem;
    }

    .container_roas .form-group-roas label {
      font-size: 0.75rem;
    }

    .container_roas .form-group-roas input,
    .container_roas .form-group-roas select {
      padding: 0.5rem;
      font-size: 0.875rem;
    }

    .container_roas .submit-button {
      padding: 0.75rem 1rem;
      font-size: 0.875rem;
    }

    .container_roas .error-message {
      padding: 0.75rem;
      font-size: 0.75rem;
    }

    .container_roas .error-icon {
      width: 1rem;
      height: 1rem;
    }

    .container_roas .results-header h2 {
      font-size: 1.25rem;
    }

    .container_roas .metrics-grid {
      grid-template-columns: 1fr;
      gap: 1rem;
      padding: 1rem;
    }

    .container_roas .metric-card {
      padding: 1rem;
    }

    .container_roas .metric-value {
      font-size: 1.5rem;
    }

    .container_roas .metric-header h3 {
      font-size: 1rem;
    }

    .container_roas .trend-icon,
    .container_roas .target-icon,
    .container_roas .chart-icon {
      width: 1.25rem;
      height: 1.25rem;
    }

    .container_roas .recommendations {
      padding: 1rem;
    }

    .container_roas .recommendations-header {
      display: block; /* Changed from flex to block to stack elements vertically */
    }

    .container_roas .recommendations-header h2 {
      font-size: 1.25rem;
      margin-bottom: 0.25rem; /* Add spacing below h2 */
    }

    .container_roas .recommendations-header span {
      font-size: 0.75rem;
      display: block; /* Ensure span is on a new line */
    }

    .container_roas .recommendations-grid {
      grid-template-columns: 1fr;
      gap: 1rem;
    }

    .container_roas .recommendation-item {
      padding: 0.75rem;
    }

    .container_roas .recommendation-number {
      width: 1.5rem;
      height: 1.5rem;
      font-size: 0.75rem;
    }

    .container_roas .recommendation-text {
      font-size: 0.875rem;
    }
  }
`;